// Vivette scroll-reveal: adds .is-visible to .v-reveal elements as they enter view.
(function () {
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  var reveal = function () {
    var els = document.querySelectorAll('.v-reveal:not(.is-visible)');
    if (!('IntersectionObserver' in window)) { els.forEach(function (e) { e.classList.add('is-visible'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) { entry.target.classList.add('is-visible'); io.unobserve(entry.target); }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
    els.forEach(function (e) { io.observe(e); });
  };
  if (document.readyState !== 'loading') reveal(); else document.addEventListener('DOMContentLoaded', reveal);
  // Re-scan when the Theme Editor injects/reorders sections.
  document.addEventListener('shopify:section:load', reveal);
})();
